<template>
  <Popup v-model="showAddress" position="bottom">
    <div class="address-popup" :class="{ graybg: !isAdd }">
      <div class="address-popup__handle"></div>
      <div class="address-popup__title-row">
        <div class="address-popup__title">{{ title }}</div>
        <button type="button" class="address-popup__close" @click="close" :aria-label="$t('cancel')">
          <span>×</span>
        </button>
      </div>
      <div class="address-popup__divider"></div>
      <div class="address-popup__content">
        <template v-if="isAdd">
          <AddressEdit :key="addressEditKey" @success="onAddEditSuccess" :editAddress="editAddress"></AddressEdit>
        </template>
        <template v-else>
          <div class="address-popup__list">
            <AddressList @addNew="addNew" :defaultSelectId="defaultSelectId" @change="onChange" @edit="openEdit"
              @delete="onDelete">
            </AddressList>
          </div>
        </template>
      </div>
    </div>
  </Popup>
</template>

<script>
import { Popup } from 'vant';
import AddressEdit from './AddressEdit.vue';
import AddressList from './AddressList.vue';
export default {
  name: 'AddressPopup',
  components: {
    Popup,
    AddressEdit,
    AddressList
  },
  props: {
    defaultSelectId: {
      type: [Number, String],
      default: ''
    },
  },
  data() {
    return {
      showType: 1,  // 1: 新增地址，2: 选择地址
      showAddress: false,
      editAddress: null,
      addressEditKey: 0,
    }
  },
  computed: {
    isAdd() {
      return this.showType === 1;
    },
    title() {
      if (this.isAdd) {
        return this.$t('addAddress');
      } else {
        return this.$t('addressList');
      }
    },
  },
  methods: {
    open({ showType = 1, editAddress = null } = {}) {
      this.showType = showType;
      this.editAddress = editAddress;
      if (showType === 1) this.addressEditKey += 1;
      this.showAddress = true;
      if(showType  === 2){
        this.$store.dispatch('user/getAddressList')
      }
    },

    close() {
      this.showAddress = false;
      this.editAddress = null;
    },
    addNew() {
      this.editAddress = null;
      this.addressEditKey += 1;
      this.showType = 1;
    },
    onAddEditSuccess({ data }) {
      this.editAddress = null;
      this.$emit('change', {
        data
      });
      this.close();
    },
    onChange({ data }) {
      this.$emit('change', { data });
      this.close();
    },
    openEdit({ data }) {
      this.editAddress = data
      this.addressEditKey += 1;
      this.showType = 1;
    },
    onDelete({ data }) {
      this.$emit('delete', { data });
    }
  }
}
</script>

<style lang="less" scoped>
.van-popup {
  background: none;
}

.van-checkbox /deep/ .van-checkbox__label {
  font-size: 32px;
  line-height: 40px;
  color: var(--text-color-gray);
}

.sm-radius {
  border-radius: var(--border-radius-base);
}

.address-popup {
  width: 750px;
  padding: 12px 32px 18px;
  box-sizing: border-box;
  background: #FFFFFF;
  border-radius: 50px 50px 0px 0px;
  filter: blur(0px);
  position: relative;

  &.graybg {
    background: var(--bg-color-gray);
  }

  &__close {
    width: 48px;
    height: 48px;
    border: 0;
    border-radius: 50%;
    background: #F4F6FB;
    color: #6F7482;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;

    span {
      font-size: 42px;
      line-height: 42px;
      font-weight: 300;
      transform: translateY(-2px);
    }
  }

  &__handle {
    width: 72px;
    height: 7px;
    border-radius: 999px;
    background: #DEE3EF;
    margin: 0 auto 20px;
  }

  &__title-row {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__title {
    color: #020B3A;
    font-size: 34px;
    line-height: 42px;
    font-weight: 500;
  }

  &__divider {
    height: 1px;
    background: #E1E5EF;
    margin: 20px 0;
  }

  &__content {
    height: auto;
    max-height: 72vh;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
}
</style>
